// components, keys, and utils
import { FilterDropdownTypes, IFilterDropdown } from '../../../components/FilterDropdown/FilterDropdown';
import { ActivityStatus } from '../TableColumns/ActivityTagColumn';
import EntityLookup from '../../../../../lookups/EntityLookup';
import OwnerLookup from '../../../../../lookups/OwnerLookup';

// generated
import { EntityType } from '../../../../../../types.generated';

export enum OperatorType {
    EQUAL = 'EQUAL',
    CONTAIN = 'CONTAIN',
    IN = 'IN',
    GREATER_THAN = 'GREATER_THAN',
    GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
    LESS_THAN = 'LESS_THAN',
    LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
}

export const BrowseDataProductFilters: IFilterDropdown[] = [
    {
        id: 'dataProducts',
        name: 'Data Product',
        type: FilterDropdownTypes.CUSTOM,
        entityType: EntityType.DataProduct,
        placeholder: 'Select the Data Product',
        CustomRender: EntityLookup,
        operators: [
            {
                label: 'Equal',
                value: OperatorType.EQUAL,
            },
        ],
    },
    {
        id: 'domains',
        name: 'Domain',
        type: FilterDropdownTypes.CUSTOM,
        entityType: EntityType.Domain,
        placeholder: 'Select the Domain',
        CustomRender: EntityLookup,
        operators: [
            {
                label: 'Equal',
                value: OperatorType.EQUAL,
            },
        ],
    },
    {
        id: 'glossaryTerms',
        name: 'Glossary Terms',
        type: FilterDropdownTypes.CUSTOM,
        entityType: EntityType.GlossaryTerm,
        placeholder: 'Select the Glossary Term',
        CustomRender: EntityLookup,
        operators: [
            {
                label: 'Equal',
                value: OperatorType.EQUAL,
            },
        ],
    },
    {
        id: 'tags',
        name: 'Tags',
        type: FilterDropdownTypes.CUSTOM,
        entityType: EntityType.Tag,
        placeholder: 'Select the Tag',
        CustomRender: EntityLookup,
        operators: [
            {
                label: 'Equal',
                value: OperatorType.EQUAL,
            },
        ],
    },
    {
        id: 'owners',
        name: 'Owner',
        type: FilterDropdownTypes.CUSTOM,
        placeholder: 'Select the Owner',
        CustomRender: OwnerLookup,
        operators: [
            {
                label: 'Equal',
                value: OperatorType.EQUAL,
            },
        ],
    },
];

export const FilterOptions: IFilterDropdown[] = [
    {
        id: 'time',
        name: 'Time',
        type: FilterDropdownTypes.TIME,
        operators: [
            {
                label: 'Greater than',
                value: OperatorType.GREATER_THAN,
            },
            {
                label: 'Greater than or equal to',
                value: OperatorType.GREATER_THAN_OR_EQUAL_TO,
            },
            {
                label: 'Less than',
                value: OperatorType.LESS_THAN,
            },
            {
                label: 'Less than or equal to',
                value: OperatorType.LESS_THAN_OR_EQUAL_TO,
            },
        ],
    },
    {
        id: 'activity',
        name: 'Activity',
        type: FilterDropdownTypes.DROP_DOWN,
        dropDownOptions: (Object.keys(ActivityStatus) as (keyof typeof ActivityStatus)[]).reduce((acc, cur) => {
            acc.push({ label: cur, value: cur });
            return acc;
        }, [] as { label: string; value: string | number }[]),
        operators: [
            {
                label: 'Equal',
                value: OperatorType.EQUAL,
            },
        ],
    },
    {
        id: 'aspect',
        name: 'Attribute',
        type: FilterDropdownTypes.INPUT,
        operators: [
            {
                label: 'Equal',
                value: OperatorType.EQUAL,
            },
            {
                label: 'Contain',
                value: OperatorType.CONTAIN,
            },
        ],
    },
    {
        id: 'oldValue',
        name: 'Old Value',
        type: FilterDropdownTypes.INPUT,
        operators: [
            {
                label: 'Equal',
                value: OperatorType.EQUAL,
            },
            {
                label: 'Contain',
                value: OperatorType.CONTAIN,
            },
        ],
    },
    {
        id: 'newValue',
        name: 'New Value',
        type: FilterDropdownTypes.INPUT,
        operators: [
            {
                label: 'Equal',
                value: OperatorType.EQUAL,
            },
            {
                label: 'Contain',
                value: OperatorType.CONTAIN,
            },
        ],
    },
    {
        id: 'actorUrn',
        name: 'User',
        type: FilterDropdownTypes.CUSTOM,
        CustomRender: OwnerLookup,
        operators: [
            {
                label: 'Equal',
                value: OperatorType.EQUAL,
            },
        ],
    },
];

export const glossaryFilters: IFilterDropdown[] = [
    {
        id: 'subTypes',
        name: 'SubType',
        type: FilterDropdownTypes.INPUT,
        operators: [
            {
                label: 'Equal',
                value: OperatorType.EQUAL,
            },
        ],
    },
    {
        id: 'domains',
        name: 'Domain',
        type: FilterDropdownTypes.CUSTOM,
        entityType: EntityType.Domain,
        CustomRender: EntityLookup,
        operators: [
            {
                label: 'Equal',
                value: OperatorType.EQUAL,
            },
        ],
    },
    {
        id: 'dataProducts',
        name: 'Data Product',
        type: FilterDropdownTypes.CUSTOM,
        entityType: EntityType.DataProduct,
        CustomRender: EntityLookup,
        operators: [
            {
                label: 'Equal',
                value: OperatorType.EQUAL,
            },
        ],
    },
    {
        id: 'owners',
        name: 'Owner',
        type: FilterDropdownTypes.CUSTOM,
        CustomRender: OwnerLookup,
        operators: [
            {
                label: 'Equal',
                value: OperatorType.EQUAL,
            },
        ],
    },
];
